import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import './snippetcontainer.scss'
import { WorkspaceContext } from '../WorkspaceContext'
import axios from 'axios'
import EditIcon from '../../../shared/components/svgIcons/EditIcon'
import TrashIcon from '../../../shared/components/svgIcons/TrashIcon'
import './popup.scss'
import api from '../../../api'
import { getSnippetExtension } from '../../../shared/utils/getFileIconAndExtensionHelper'
import ViewOnly from './ViewOnly'
import CanEdit from './CanEdit'

//instead of just hiding it to non editors i will show it but they can not be able to change the name or edit anything. to make it easier so i do not have to add all helper functions i am just passing it in as a prop
interface settingPopupProps {
    initialState: string;
    onClose: () => void;
    initialPerm: string;
    viewerPerm: 'viewer' | 'editor'
}









const SnipSettingPopup: React.FC<settingPopupProps> = ({ initialState, onClose, initialPerm, viewerPerm }) => {
    const API = process.env.REACT_APP_API_URL;

    const { roomId } = useParams();

    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");
    const { activeSnippet, activeSnippetId, membersList, roomSettings, setLimitMessage, setLimitPopup } = ctx;
    const clientId = ctx.clientId || localStorage.getItem("flashroom_id");
    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState(initialState);
    const [activePerm, setActivePerm] = useState(initialPerm)

    const snip = activeSnippet ? activeSnippet : null;


    const [deleteAssure, setDeleteAssure] = useState(false)

    const snipExt = activeSnippet && activeSnippet.snippetLanguage ? getSnippetExtension(activeSnippet.snippetLanguage) : 'txt';


    // keep in sync if active snippet changes while popup is open
    useEffect(() => {
        setName(initialState);
    }, [initialState]);

    const startEdit = () => {
        setIsEditing(true);
    };

    const handlePermToggle = (perm: string) => {
        setActivePerm(perm);
    }

    const finishEdit = (commit: boolean) => {
        setIsEditing(false);

        if (!commit) {
            setName(initialState);
            return;
        }

        const trimmed = name.trim();
        if (!trimmed) {
            // optional: prevent empty name
            setName(initialState);
            return;
        }

        // 🔧 put your rename logic here if you want to update global state
        // e.g. renameSnippet(activeSnippetId, trimmed);
    };

    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (e.key === "Enter") {
            finishEdit(true);
        } else if (e.key === "Escape") {
            finishEdit(false);
        }


    };



    const changeSettingClick = async (snippetName: string, snippetPermissions: string) => {
        try {
            if (!activeSnippetId) return
            await api.patch(`/snippets/updatesnippet/${roomId}/${activeSnippetId}`, {
                snippetName: snippetName,
                snipPermissions: snippetPermissions

            })

            onClose()
        } catch (error) {
            setLimitMessage('Could not update snippet settings. Please try again.');
            setLimitPopup(true);
        }
    }


    const deleteSnippetClick = async () => {
        try {
            await api.delete(`/snippets/${activeSnippetId}/room/${roomId}`)

            setDeleteAssure(false)
            onClose()

        } catch (error) {
            setLimitMessage('Could not delete snippet. Please try again.');
            setLimitPopup(true);
        }
    }


    function getMemberName() {
        if (!activeSnippet) return
        const member = membersList.find((m) => m.clientId === activeSnippet.createdBy);
        return { name: member?.name ?? "Unknown", iconColor: member?.iconColor };
    }

    const creatorDetails = getMemberName();
    const creatorName = activeSnippet?.createdBy === clientId ? 'you' : creatorDetails?.name;


    function canSubmit() {
        if (!name) return false
        if (name === initialState && activePerm === initialPerm) return false

        return true

    }



    function timeAgo(dateInput: string | number | Date): string {
        const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
        const diffInSeconds = Math.floor((Date.now() - date.getTime()) / 1000);

        if (diffInSeconds < 5) return "just now";
        if (diffInSeconds < 60) return `${diffInSeconds} second${diffInSeconds === 1 ? "" : "s"} ago`;

        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60)
            return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24)
            return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;

        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7)
            return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;

        // optional: for older stuff, just show the date
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    }

    const submitAllowed = canSubmit();

    return (
        <div id='snip-setting-popup' className='relative fade-in'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                {viewerPerm === 'editor' ? (
                    <div id='snip-setting-rename' className='relative' style={{ position: 'relative' }}>
                        <div id='edit-icon'>
                            <EditIcon />
                        </div>
                        {isEditing ? (
                            <div className="snip-name-edit-row">
                                <input
                                    value={name}
                                    maxLength={20}
                                    onChange={(e) => setName(e.target.value)}
                                    onBlur={() => finishEdit(true)}
                                    onKeyDown={handleKeyDown}
                                    autoFocus
                                />
                                <span className="snip-extension-suffix">.{snipExt}</span>
                            </div>
                        ) : (
                            <div onClick={startEdit} style={{ width: '100%' }}>

                                <span
                                    style={{ cursor: "text" }}

                                    title="Click to rename"
                                >
                                    {name}.{snipExt}
                                </span>
                            </div>
                        )}
                    </div>
                ) : (
                    <h3 className='snip-setting-name'>{name}.{snipExt}</h3>
                )}


                <button className='ns-cancel' onClick={onClose}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>


            </div>

            <div id='snip-set-line' />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                {roomSettings.trackMembersEnabled && (
                    <div style={{
                        display: 'flex',
                        width: '50px',
                        height: '50px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '50%', // or '9999px' if you like
                        backgroundColor: creatorDetails?.iconColor, // fallback color
                    }}>
                        <span className='m-i-c'>{creatorDetails?.name.slice(0, 1)}</span>
                    </div>
                )}

                <div className='name-and-updated'>
                    {roomSettings.trackMembersEnabled && (
                        <p style={{ marginBottom: '3px' }}>{creatorName}</p>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <EditIcon />
                        <span>
                            {activeSnippet?.updatedAt && timeAgo(activeSnippet.updatedAt)}
                        </span>

                    </div>

                </div>

            </div>

            <div className='mar-top' />
            {
                viewerPerm === 'editor' ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <p>Permissions</p>
                        <EditIcon />
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <p>Permissions</p>
                    </div>
                )
            }



            {
                viewerPerm === 'editor' ? (
                    <div style={{ display: 'flex', justifyContent: 'flex-start', margin: '5px auto' }}>

                        <div className='c-o-t'>
                            <div className={`clickable ns-btn nsl quick-flex ${activePerm === 'view' ? 'active-ns-type' : ''}`}
                                onClick={() => handlePermToggle('view')}
                            >


                                <span>Read Only</span>
                            </div>
                            <div className={`clickable ns-btn nsr quick-flex ${activePerm === 'edit' ? 'active-ns-type' : ''}`} onClick={() => handlePermToggle('edit')}>


                                <span>Open</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        {activePerm === 'edit' ? (
                            <div className='perm-view'>
                                <CanEdit />
                                <p>Anyone can edit this snippet</p>
                            </div>
                        ) : (
                            <div className='perm-view'>
                                <ViewOnly />
                                <p>You can only view, copy, and download this file</p>
                            </div>
                        )}
                    </div>
                )
            }









            {viewerPerm === 'editor' &&

                <div className={`${submitAllowed ? 'setting-save-good' : 'setting-save-bad'} setting-pop-bb`}>
                    <button
                        disabled={!submitAllowed}
                        onClick={() => {
                            if (!submitAllowed) return;
                            changeSettingClick(name, activePerm);
                        }}
                        className={`snip-setting-button ${!submitAllowed ? 'cannot-submit-perm' : ''}`}
                    >
                        Save Changes
                    </button>

                    <button onClick={onClose}>Cancel</button>
                </div>
            }


            {deleteAssure &&
                <div className='delete-assure'>
                    <h2>Are you Sure you want to delete this file</h2>

                    <div className='da-b'>
                        <button className='da-no' onClick={() => setDeleteAssure(false)}>No</button>
                        <button className='da-yes' onClick={deleteSnippetClick}>Yes</button>
                    </div>
                </div>
            }

            {viewerPerm === 'editor' &&
                <div className="snip-danger">
                    <button
                        onClick={() => setDeleteAssure(true)}
                        className="snip-danger-btn"

                    >
                        <TrashIcon />
                        <span>Delete File</span>
                    </button>
                </div>
            }




        </div>
    )
}

export default SnipSettingPopup
